export default __webpack_public_path__ + "static/india_map-5327ba9cb7ed67d575a532938eefcb7a.svg";